import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { add, remove, reset } from "actions/TaggedInputText";
import { validateEmail } from "utils/emailRegex";
import "./taggedInputText.scss";

const components = {
  DropdownIndicator: null
};

const colourStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: "white",
    border: "1px solid #737274",
    "box-shadow": "none",
    ":hover": {
      border: "1px solid #737274"
    }
  }),
  clearIndicator: styles => ({ ...styles, cursor: "pointer" }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.color,
    backgroundColor: "#e1e1e1"
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    ":hover": {
      cursor: "pointer"
    }
  })
};

const createOption = label => ({
  label,
  value: label
});

const callPropsOnChange = (props, newOptions, newOptionFromInputValue) => {
  if (!!props.onChange) {
    props.onChange(newOptions, {
      action: "add-value",
      addedValue: newOptionFromInputValue
    });
  }
};

class TaggedInputText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: ""
    };
    this.props.reset();
  }

  handleChange = (value, actionMeta) => {
    if (
      actionMeta.action === "remove-value" ||
      actionMeta.action === "pop-value"
    ) {
      this.props.remove(actionMeta.removedValue);
    }
    if (actionMeta.action === "clear") {
      this.props.reset(actionMeta.removedValue);
    }
    callPropsOnChange(this.props, value, actionMeta);
  };

  handleInputChange = inputValue => {
    if (inputValue.includes(",")) {
      const newValue = inputValue.replace(new RegExp(",", "g"), "");
      this.setState({ inputValue: newValue });
    } else {
      this.setState({ inputValue });
    }
  };

  handleMultiOption(value) {
    const newOptionFromInputValue = createOption(value);
    const newOptions = [...this.props.values, newOptionFromInputValue];
    if (!!this.props.validate) {
      this.props.validate(newOptions, newOptionFromInputValue);
    }
    this.handleInputChange("");
    this.props.add(newOptionFromInputValue);
    callPropsOnChange(this.props, newOptions, newOptionFromInputValue);
  }

  dealWithKeyInputAndLostFocus = event => {
    if (!this.state.inputValue) {
      return;
    }
    if (this.state.inputValue.includes(" ")) {
      const multiValue = this.state.inputValue.split(" ");
      const validEmails = multiValue
        .map(value => validateEmail(value))
        .filter(Boolean);
      validEmails.map(value => this.handleMultiOption(value));
      return;
    }
    if (validateEmail(this.state.inputValue)) {
      const newOptionFromInputValue = createOption(this.state.inputValue);
      const newOptions = [...this.props.values, newOptionFromInputValue];
      if (!!this.props.validate) {
        this.props.validate(newOptions, newOptionFromInputValue);
      }
      this.handleInputChange("");
      this.props.add(newOptionFromInputValue);
      callPropsOnChange(this.props, newOptions, newOptionFromInputValue);
      event.preventDefault();
    }
  };

  handleKeyDown = event => {
    const { inputValue } = this.state;
    if (!inputValue) {
      return;
    }
    switch (event.key) {
      case "Enter":
        this.dealWithKeyInputAndLostFocus(event);
        break;
      case "Tab":
        this.dealWithKeyInputAndLostFocus(event);
        break;
      default:
        break;
    }
  };

  render() {
    return (
      <Select
        components={components}
        inputValue={this.state.inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={this.handleChange}
        onBlur={this.dealWithKeyInputAndLostFocus}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        placeholder=""
        value={this.props.values}
        styles={colourStyles}
        className="lc_react-select-container"
        classNamePrefix="lc_react-select"
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    values: state.taggedInputTextReducer.values
  };
};

const mapDispatchToProps = dispatch => {
  return {
    add: option => dispatch(add(option)),
    remove: option => dispatch(remove(option)),
    reset: () => dispatch(reset())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaggedInputText);



// WEBPACK FOOTER //
// ./src/components/UI/TaggedInputText/index.js